<script>
  import Video from "./Video.svelte";
  // import Navbar from "./Navbar.svelte";
  import metacombined from "./metacombined.json";
  // import BigNumber from "bignumber.js";
  // import { COLLECTION_ID } from "./constants";

  import { onMount } from "svelte";
  let movie;
  let hidden;

  onMount(() => {
    // window.scrollTo(0, 0);
    if (window.location.hash.slice(1) === "0") {
      movie.currentTime = 0.1;
      movie.pause();
      return;
    }
    const amount = parseInt(window.location.hash.slice(1));
    if (amount) {
      hidden = true;
      movie.currentTime = (amount+0.4) - 1;
      movie.pause();
      console.log('ok', movie)
    }
  });

  export let id;

  let boy = metacombined[id];
  let descriptionChunks = boy.description.split("\n").map((d) => d.split(":"));

  let ordersMap = {};
  // fetch(
  //   "https://api.rarible.com/protocol/v0.1/ethereum/order/orders/sell/byCollection?collection=" +
  //     COLLECTION_ID
  // )
  //   .then((r) => {
  //     return r.json();
  //   })
  //   .then(({ orders }) => {
  //     console.log(orders);
  //     orders.forEach((order) => {
  //       ordersMap[order.make.assetType.tokenId] = order;
  //     });
  //   });

  // function formatOrder(order) {
  //   try {
  //     return new BigNumber(order.take.value)
  //       .div("1000000000000000000")
  //       .toNumber();
  //   } catch (e) {
  //     console.error(e);
  //     return "err";
  //   }
  // }
</script>

<div class="bg-blackSplash text-white min-h-full">
  <div class="md:p-20 p-10 text-center">
    <h3 class="font-pixel mb-10 text-center text-4xl">
      THE BOYS >> {boy.name}
    </h3>
    <div class="flex justify-center">
      <div class="fullpage">
        <!-- <Video
          poster={boy.image}
          size=""
          bind:this={movie}
          src={boy.animation_url}
        /> -->
        <video
          src={boy.animation_url}
          bind:this={movie}
          width=""
          height=""
          volume="0"
        >
          <track kind="captions" />
        </video>
      </div>
      <div class="fullpage">
        <div
          class:hidden
          class="p-8"
          style="background:rgba(0, 0, 0, 0.6); min-height: 100%;"
        >
          <h5 class="font-pixel text-6xl md:text-6xl p-4">{boy.name}</h5>
          <div
            class="text-left text-3xl md:text-3xl font-pixel text-gray-300 line-height-0.5 self-start"
          >
            {#each descriptionChunks as descriptionChunk}
              {#if ["PROS", "CONS"].includes(descriptionChunk[0])}
                <p class="p-3">
                  <strong>{descriptionChunk[0]}</strong><br />
                  {descriptionChunk[1] || ""}
                </p>
              {/if}
            {/each}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
